import * as yup from 'yup';

const loginValidation = yup.object().shape({
    email: yup.string()
        .email('Invalid email address')
        .required('Email is required'),

    password: yup.string().required("password is required").matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&])(?=.{8,})/, // rejex
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ).max(16, "don't allow more than 16"),
});

const contactValidation = yup.object().shape({
    firstName: yup.string()
        .max(15, 'Must be 15 characters or less').min(3, 'Atleast have 3 Characters')
        .required('firstName is required'),

    lastName: yup.string()
        .max(20, 'Must be 20 characters or less').min(3, 'Atleast have 3 Characters')
        .required('lasttName is required'),

    phone: yup.number()
        .required('A phone number is required')
        .typeError("That doesn't look like a phone number")
        .positive("A phone number can't start with a minus")
        .integer("A phone number can't include a decimal point")
        .min(10),

    email: yup.string().email('Invalid email address').required('Email is required'),

    message: yup.string()
        .required('Message is required'),
});

const forgetpwdValidation = yup.object().shape({

    email: yup.string().email('Invalid email address').required('Email is required'),

});

const resetpwdValidation = yup.object().shape({

    password: yup.string().required("password is required").matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&])(?=.{8,})/, // rejex
        "Must Contain 16 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ).max(16, "don't allow more than 16"),

    confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Passwords miss match').required("password is required").max(16, "don't allow more than 16")

});

const userprofileValidation = yup.object().shape({
    firstName: yup.string()
        .max(15, 'Must be 15 characters or less').min(3, 'Atleast have 3 Characters')
        .required('firstName is required'),

    lastName: yup.string()
        .max(20, 'Must be 20 characters or less').min(3, 'Atleast have 3 Characters')
        .required('lasttName is required'),

    phone: yup.number()
        .required('A phone number is required')
        .typeError("That doesn't look like a phone number")
        .positive("A phone number can't start with a minus")
        .integer("A phone number can't include a decimal point")
        .min(10),

    email: yup.string().email('Invalid email address').required('Email is required'),
    
});


export { loginValidation, contactValidation, forgetpwdValidation, resetpwdValidation, userprofileValidation }